/* @generated */

// ../src/banner/banner.tsx
import * as React4 from "react";
import classNames2 from "classnames";

// ../src/utils.ts
import * as React from "react";
var weakInvariant = (condition, message2, error) => {
  if (!condition) {
    console.error(`dig-components:`, message2, error);
  }
};

// ../src/banner/message.tsx
import classNames from "classnames";
import * as React2 from "react";
import { Text } from "@dropbox/dig-components/typography";

// ../src/banner/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var actions = "dig-w54z3i2_22-5-0";
var bannerVariants = _7a468({ defaultClassName: "dig-w54z3i4_22-5-0", variantClassNames: { type: { attention: "dig-w54z3i5_22-5-0", success: "dig-w54z3i6_22-5-0", warning: "dig-w54z3i7_22-5-0", alert: "dig-w54z3i8_22-5-0", neutral: "dig-w54z3i9_22-5-0" }, variant: { basic: "dig-w54z3ia_22-5-0", rich: "dig-w54z3ib_22-5-0" }, isVis2023: { true: "dig-w54z3ic_22-5-0" }, withCloseBtn: { true: "dig-w54z3id_22-5-0" }, withIcon: { true: "dig-w54z3ie_22-5-0" }, withPictogram: { true: "dig-w54z3if_22-5-0" } }, defaultVariants: { variant: "basic", withIcon: true, type: "neutral", isVis2023: false, withPictogram: false }, compoundVariants: [[{ variant: "rich", withCloseBtn: true }, "dig-w54z3ig_22-5-0"], [{ variant: "basic", withIcon: true }, "dig-w54z3ih_22-5-0"], [{ variant: "rich", withPictogram: true }, "dig-w54z3ii_22-5-0"]] });
var closeBtn = "dig-w54z3i1_22-5-0";
var icon = "dig-w54z3i3_22-5-0";
var message = "dig-w54z3i0_22-5-0";

// ../src/banner/message.tsx
import { useHumanReadableAttributesProvider } from "@dropbox/dig-foundations";
var Message = ({ className = "", children }) => {
  const { shouldRenderHumanReadableAttributes } = useHumanReadableAttributesProvider();
  const cls = classNames(
    { "dig-Banner-message": shouldRenderHumanReadableAttributes },
    message,
    className
  );
  return /* @__PURE__ */ React2.createElement(Text, { className: cls }, children);
};
Message.displayName = "Banner.Message";

// ../src/banner/actions.tsx
import * as React3 from "react";
import cx from "classnames";
import { useHumanReadableAttributesProvider as useHumanReadableAttributesProvider2 } from "@dropbox/dig-foundations";
var Actions = ({ className = "", children, ...rest }) => {
  const { shouldRenderHumanReadableAttributes } = useHumanReadableAttributesProvider2();
  return /* @__PURE__ */ React3.createElement(
    "span",
    {
      className: cx(
        { "dig-Banner-actions": shouldRenderHumanReadableAttributes },
        actions,
        className
      ),
      ...rest
    },
    children
  );
};
Actions.displayName = "Banner.Actions";

// ../src/banner/banner.tsx
import { IconButton } from "@dropbox/dig-components/buttons";
import {
  CloseLine,
  InfoLine,
  WarningLine,
  CheckmarkCircleLine,
  InfoPictogram,
  WarningPictogram,
  CheckmarkCirclePictogram,
  FailLine,
  FailPictogram
} from "@dropbox/dig-icons/assets";
import { UIIcon } from "@dropbox/dig-icons";
import { PictogramIcon } from "@dropbox/dig-icons";
import { useTheme, atoms, useHumanReadableAttributesProvider as useHumanReadableAttributesProvider3 } from "@dropbox/dig-foundations";
var icon2 = (variant, type) => {
  if (variant === "basic") {
    switch (type) {
      case "attention":
        return InfoLine;
      case "success":
        return CheckmarkCircleLine;
      case "warning":
        return WarningLine;
      case "alert":
        return FailLine;
      default:
        return InfoLine;
    }
  } else {
    switch (type) {
      case "attention":
        return InfoPictogram;
      case "success":
        return CheckmarkCirclePictogram;
      case "warning":
        return WarningPictogram;
      case "alert":
        return FailPictogram;
      default:
        return InfoPictogram;
    }
  }
};
var BannerIcon = ({ variant = "basic", type = "neutral", withLeftIcon, withLeftPictogram }) => {
  const { shouldRenderHumanReadableAttributes } = useHumanReadableAttributesProvider3();
  const cls = classNames2({ "dig-Banner-icon": shouldRenderHumanReadableAttributes }, icon);
  if (variant === "basic") {
    if (!withLeftIcon || withLeftIcon === true && type === "neutral") {
      return null;
    }
    if (withLeftIcon === true) {
      return /* @__PURE__ */ React4.createElement(UIIcon, { className: cls, src: icon2(variant, type), size: "medium" });
    }
    weakInvariant(
      withLeftIcon.type === UIIcon,
      "The Banner component only accepts `<UIIcon />` in the `withLeftIcon` prop."
    );
    return /* @__PURE__ */ React4.createElement("span", { className: cls }, withLeftIcon);
  } else {
    if (!withLeftPictogram && type === "neutral" || withLeftPictogram === null) {
      return null;
    }
    if (withLeftPictogram) {
      weakInvariant(
        withLeftPictogram.type === PictogramIcon,
        "The Banner component only accepts `<PictogramIcon />` in the `withLeftPictogram` prop."
      );
      return /* @__PURE__ */ React4.createElement("div", { className: cls }, withLeftPictogram);
    }
    return /* @__PURE__ */ React4.createElement(PictogramIcon, { className: cls, src: icon2(variant, type) });
  }
};
BannerIcon.displayName = "BannerIcon";
var Banner = (props) => {
  const {
    children,
    className,
    type = "neutral",
    onRequestClose,
    withCloseButton,
    withLeftIcon = true,
    withLeftPictogram,
    variant = "basic",
    borderRadius = "Large",
    ...rest
  } = props;
  const { theme } = useTheme();
  const { shouldRenderHumanReadableAttributes } = useHumanReadableAttributesProvider3();
  return /* @__PURE__ */ React4.createElement(
    "div",
    {
      role: "alert",
      className: classNames2(
        {
          "dig-Banner": shouldRenderHumanReadableAttributes,
          [`dig-Banner--${type}`]: shouldRenderHumanReadableAttributes,
          [`dig-Banner--${variant}`]: shouldRenderHumanReadableAttributes,
          "dig-Banner--withCloseButton": shouldRenderHumanReadableAttributes && withCloseButton,
          "dig-Banner--withPictogram": shouldRenderHumanReadableAttributes && withLeftPictogram,
          "dig-Banner--withIcon": shouldRenderHumanReadableAttributes && withLeftIcon
        },
        className,
        bannerVariants({
          variant,
          type,
          withCloseBtn: !!withCloseButton,
          withPictogram: !!withLeftPictogram,
          withIcon: !!withLeftIcon,
          isVis2023: theme === "vis2023"
        }),
        atoms({ borderRadius })
      ),
      ...rest
    },
    /* @__PURE__ */ React4.createElement(
      BannerIcon,
      {
        variant,
        type,
        withLeftIcon,
        withLeftPictogram
      }
    ),
    /* @__PURE__ */ React4.createElement("span", null, children),
    !!withCloseButton && /* @__PURE__ */ React4.createElement(
      IconButton,
      {
        variant: "transparent",
        className: classNames2(
          { "dig-Banner-close": shouldRenderHumanReadableAttributes },
          closeBtn
        ),
        "aria-label": withCloseButton,
        "data-testid": shouldRenderHumanReadableAttributes ? "digBannerCloseButton" : void 0,
        onClick: onRequestClose
      },
      /* @__PURE__ */ React4.createElement(UIIcon, { src: CloseLine })
    )
  );
};
Banner.displayName = "Banner";
Banner.Actions = Actions;
Banner.Message = Message;
export {
  Banner
};
